import http from '@/utils/http';

export default {
	save: data => {
		return http({url:'/api/admin/v1/dept/save',data,tip:true,loading:true}).then(r => r);
	},
	delete: data => {
		return http({url:'/api/admin/v1/dept/delete',data,tip:true,loading:true}).then(r => r);
	},
	list: data => {
		return http({url:'/api/admin/v1/dept/list',data}).then(r => r);
	},
	listAll: () => {
		return http({url:'/api/admin/v1/dept/listAll'}).then(r => r);
	},
}